<template>
  <div>
    <breadcrumbs home="Site"/>

    <v-card flat width="100%">

      <v-form v-model="valid" ref="form" :disabled="readOnly">
        <v-container class="px-6 pt-8 purtrak-scrollable" fluid>

          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-text-field label="Name" v-model="site.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
            </v-col>
            <v-col cols="2" lg="1">
              <v-checkbox label="Active" v-model="site.active" class="mt-1"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="2">
              <v-checkbox label="Preferred" v-model="site.preferred" class="mt-1" :disabled="site.nonExcise"/>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-autocomplete :items="sharedSites" v-model="site.shareLicenseWithSiteId" item-text="name" item-value="id"
                        label="Shares licenses with" outlined dense @change="changeLicense" :disabled="site.nonExcise"/>
            </v-col>
          </v-row>

          <v-row dense>
            <v-checkbox v-model="site.B266" class="mt-1"/>
            <v-col cols="5" sm="2">
              <v-text-field label="Spirits license" v-model="site.spiritsLicense" :rules="[fieldRules.required,fieldRules.maxLength(12)]" outlined dense
                            placeholder="xx-SL-xx"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B266"/>
            </v-col>
            <v-col cols="3" sm="1">
              <v-text-field label="BN suffix" v-model="site.spiritsSuffix" :rules="[fieldRules.required,fieldRules.maxLength(4)]" :counter="4" outlined dense
                            placeholder="0001"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B266"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-checkbox v-model="site.B262" class="mt-1"/>
            <v-col cols="5" sm="2">
              <v-text-field label="Warehouse license" v-model="site.warehouseLicense" :rules="[fieldRules.required,fieldRules.maxLength(12)]" outlined dense
                            placeholder="xx-EWL-xx"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B262"/>
            </v-col>
            <v-col cols="3" sm="1">
              <v-text-field label="BN suffix" v-model="site.warehouseSuffix" :rules="[fieldRules.required,fieldRules.maxLength(4)]" :counter="4" outlined dense
                            placeholder="0002"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B262"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-checkbox v-model="site.B263" class="mt-1"/>
            <v-col cols="5" sm="2">
              <v-text-field label="User license" v-model="site.userLicense" :rules="[fieldRules.maxLength(12)]" outlined dense
                            placeholder="xx-UL-xx"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B263"/>
            </v-col>
            <v-col cols="3" sm="1">
              <v-text-field label="BN suffix" v-model="site.userSuffix" :rules="[fieldRules.maxLength(4)]" :counter="4" outlined dense
                            placeholder="0003"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B263"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-checkbox v-model="site.B265" class="mt-1"/>
            <v-col cols="5" sm="2">
              <v-text-field label="Wine license" v-model="site.wineLicense" :rules="[fieldRules.maxLength(12)]" outlined dense
                            placeholder="xx-UL-xx"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B265"/>
            </v-col>
            <v-col cols="3" sm="1">
              <v-text-field label="BN suffix" v-model="site.wineSuffix" :rules="[fieldRules.maxLength(4)]" :counter="4" outlined dense
                            placeholder="0003"
                            :disabled="site.shareLicenseWithSiteId !== null || !site.B265"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-textarea label="Shipping address" v-model="site.shippingAddress" outlined dense no-resize :rows="3" :rules="[fieldRules.maxLength(300)]" hide-details="auto"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn :plain="!readOnly" color="primary" @click="cancel">{{readOnly?'Done':'Cancel'}}</v-btn>
        <v-btn v-if="!readOnly" color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'SettingsSitesEdit',
  mixins: [confirmLeave],
  props: {
    siteId: {type:String, required:false}
  },
  data() {
    return {
      sites: [],
      site: {active:true,spiritsSuffix:'0001',warehouseSuffix:'0002',userSuffix:'0003',wineSuffix:'0004',preferred:false,
              spiritsLicense:'xx-SL-xx',warehouseLicense:'xx-EWL-xx',userLicense:'xx-UL-xx',wineLicense:'xx-WL-xx',shareLicenseWithSiteId:null,
              B262:true,B263:false,B265:false,B266:true},
      valid: true,
      dirty: false,
      saving: false
    }
  },
  computed: {
    sharedSites() {
      return [{name:' - Unique for site - ',id:null}, ...this.sites.filter(site => site.id !== this.siteId)];
    },
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    }
  },
  watch: {
    site: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    const results = await this.$apiCall(`query SettingsSitesEdit {
                                           company {
                                              sites {
                                                id,name,active,spiritsSuffix,warehouseSuffix,userSuffix,wineSuffix,
                                                spiritsLicense,warehouseLicense,userLicense,wineLicense,
                                                B262,B263,B265,B266,
                                                shareLicenseWithSite{id},preferred
                                                shippingAddress
                                              }
                                            }
                                          }`,
                                        {id:this.siteId});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    this.sites = results.data.company.sites;
    this.sites.forEach(site => {
      site.shareLicenseWithSiteId = site.shareLicenseWithSite?.id ?? null;
      delete site.shareLicenseWithSite;
    });
    if (this.siteId) {
      this.site = this.sites.find(site => site.id === this.siteId);
      this.$nextTick(() => this.dirty = false);
    }
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    changeLicense() {
      if (this.site.shareLicenseWithSiteId) {
        const copyFromSite = this.sites.find(site => site.id === this.site.shareLicenseWithSiteId);
        this.site = {...copyFromSite, ...{id:this.site.id,name:this.site.name,active:this.site.active,shareLicenseWithSiteId:this.site.shareLicenseWithSiteId}};
      }
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const input = Object.assign({}, this.site);

      const results = await this.$apiCall(`mutation SettingsSitesEdit($input: SiteInput!) {
                                             siteCreate(input:$input) {id}
                                           }`,
                                          {input})
      if (results.error)
        return;

      await this.$store.dispatch('refreshCompanies')
      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.siteId?'Updated':'Created'} site ${input.name}`});
      });
    },
  }
}
</script>